import React from "react";
import { DataTableHeaderCell } from "src/components";

export const Header = ({ headings, onSort, onMainCheck, isSortable }) => {
    return (
        <tr>
            {headings.map((heading, index) => (
                <DataTableHeaderCell key={index}
                    style={{
                        textAlign: [0, 1, 6].includes(index) ? "center" : "left",
                        width: index === 0 ? "1rem" : index === 1 ? "5rem" : "auto",
                        cursor: isSortable(index) ? "pointer" : "auto",
                    }}
                    {...(index > 0 ? { onClick: () => onSort(index) } : {})}
                >
                    {index === 0 ? (
                        <label
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={(e) => {
                                e.preventDefault();
                                onMainCheck();
                            }}
                        >
                            {heading }
                        </label>
                    ) : (
                        heading
                    )}
                </DataTableHeaderCell>
            ))}
        </tr>
    );
};
